module.exports = __webpack_public_path__ + "static/img/ExpiredLogo.2c51a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/ExpiredLogo.png
// module id = 4v5N
// module chunks = 1